import*as e from"react";const t=e.createContext(function(){let e=!1;return{clearReset:()=>{e=!1},reset:()=>{e=!0},isReset:()=>e}}()),r=()=>e.useContext(t);export{r as useQueryErrorResetBoundary};
